import { createContext } from 'react';
const RowContext = /*#__PURE__*/createContext({});
export default RowContext;